<template>
  <div class="index_warp">
    <!-- <div class="mode">当前处于{{userInfo.mode}}</div> -->
    <div class="top_input">
      <div style="display: flex;align-items: center;gap: 24rem;">
        <a-input placeholder="输入题目ID搜索题目"
                 @keydown.enter="searchTopic"
                 v-model:value="keywords">
          <template #suffix>
            <img src="@/static/icons/search.png"
                 alt=""
                 @click="searchTopic">
            <!-- <search-outlined  /> -->
          </template>
        </a-input>
        <div style="height: 48rem;display: flex;justify-content: center;align-items: center;cursor: pointer;"
             @click="toMsg">
          <svg width="40rem"
               height="40rem"
               viewBox="0 0 40 40"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <g id="ChatTeardropDots">
              <path id="Vector"
                    d="M20.625 3.75C16.4824 3.75455 12.5108 5.40221 9.58148 8.33148C6.65221 11.2608 5.00455 15.2324 5 19.375V32.5C5 33.163 5.26339 33.7989 5.73223 34.2678C6.20107 34.7366 6.83696 35 7.5 35H20.625C24.769 35 28.7433 33.3538 31.6735 30.4235C34.6038 27.4933 36.25 23.519 36.25 19.375C36.25 15.231 34.6038 11.2567 31.6735 8.32646C28.7433 5.3962 24.769 3.75 20.625 3.75ZM20.625 32.5H7.5V19.375C7.5 16.7791 8.26977 14.2415 9.71196 12.0831C11.1542 9.92475 13.204 8.24248 15.6023 7.24908C18.0006 6.25568 20.6396 5.99576 23.1856 6.50219C25.7316 7.00862 28.0702 8.25866 29.9058 10.0942C31.7413 11.9298 32.9914 14.2684 33.4978 16.8144C34.0042 19.3604 33.7443 21.9994 32.7509 24.3977C31.7575 26.796 30.0753 28.8458 27.9169 30.288C25.7585 31.7302 23.2209 32.5 20.625 32.5ZM22.5 20C22.5 20.3708 22.39 20.7334 22.184 21.0417C21.978 21.35 21.6851 21.5904 21.3425 21.7323C20.9999 21.8742 20.6229 21.9113 20.2592 21.839C19.8955 21.7666 19.5614 21.588 19.2992 21.3258C19.037 21.0636 18.8584 20.7295 18.786 20.3658C18.7137 20.0021 18.7508 19.6251 18.8927 19.2825C19.0346 18.9399 19.275 18.647 19.5833 18.441C19.8916 18.235 20.2542 18.125 20.625 18.125C21.1223 18.125 21.5992 18.3225 21.9508 18.6742C22.3025 19.0258 22.5 19.5027 22.5 20ZM15.625 20C15.625 20.3708 15.515 20.7334 15.309 21.0417C15.103 21.35 14.8101 21.5904 14.4675 21.7323C14.1249 21.8742 13.7479 21.9113 13.3842 21.839C13.0205 21.7666 12.6864 21.588 12.4242 21.3258C12.162 21.0636 11.9834 20.7295 11.911 20.3658C11.8387 20.0021 11.8758 19.6251 12.0177 19.2825C12.1596 18.9399 12.4 18.647 12.7083 18.441C13.0166 18.235 13.3792 18.125 13.75 18.125C14.2473 18.125 14.7242 18.3225 15.0758 18.6742C15.4275 19.0258 15.625 19.5027 15.625 20ZM29.375 20C29.375 20.3708 29.265 20.7334 29.059 21.0417C28.853 21.35 28.5601 21.5904 28.2175 21.7323C27.8749 21.8742 27.4979 21.9113 27.1342 21.839C26.7705 21.7666 26.4364 21.588 26.1742 21.3258C25.912 21.0636 25.7334 20.7295 25.661 20.3658C25.5887 20.0021 25.6258 19.6251 25.7677 19.2825C25.9096 18.9399 26.15 18.647 26.4583 18.441C26.7666 18.235 27.1292 18.125 27.5 18.125C27.9973 18.125 28.4742 18.3225 28.8258 18.6742C29.1775 19.0258 29.375 19.5027 29.375 20Z"
                    fill="white" />
            </g>
          </svg>
          <span class="msg-count"
                v-if="parseInt(unreadMsgCount) != 0">{{parseInt(unreadMsgCount) > 99 ? '99+' : unreadMsgCount}}</span>

        </div>
        <!-- <div @click="toConsultation"
             style="color: #fff;display:flex; align-items: center;">
          <div><img src="@/static/consultation.png"
                 alt="" /></div>
          <div>AI学科问诊</div>
        </div>
        <div @click="toPredict"
             style="color: #fff; display:flex; align-items: center;">
          <div><img src="@/static/ai.png"
                 alt="" /></div>
          <div>AI预测中考</div>
        </div> -->
      </div>
      <div style="display: flex;align-items: center;gap:32rem">
      <div class="goal_text">为理想而战<img style=" line-height: 42rem;"
             src="@/static/medal.png"
             alt="">
      </div>
       <img src="@/static/rank.png"
       @click="toRank"
       style="height: 54rem;width: 164rem;"
             alt="">
      <button class="btn_goal"
              @click="toGoal">
        <div class="text"
             v-if="totalScore !== 0"> 目标总分 {{ totalScore }}分 ></div>
        <div class="text"
             v-else> 快去填写{{edu_grade_id==1?'中考目标':"学科目标"}}> </div>
      </button>
    </div>
    </div>
    <div style="display:flex;">
      <div class="left">
      <div class="topList">
                <div  class="topCard" @click="toPage('/quick')">

       <img src="@/static/q.png"
          style="width:56rem;height:56rem"
             alt="">
        <span >
          AI快速检测
        </span>

    </div>

        <div class="topCard" @click="toPage('/predict')">

       <img src="@/static/ai.png"
          style="width:56rem;height:56rem"
             alt="">
        <span >
          AI预测中考
        </span>

    </div>
    <div class="topCard" @click="toPage('/consultation')">

       <img src="@/static/consultation.png"
          style="width:56rem;height:56rem"
             alt="">
        <span >
          AI学科问诊
        </span>

    </div>
    <div class="topCard" @click="toPage('/mapMind')">

       <img src="@/static/center/mindMap.png"
          style="width:56rem;height:56rem"
             alt="">
        <span >
          AI导学
        </span>

    </div>
        <div class="topCard" @click="toPage('/chatAI')" v-show="aiChatState">

           <img src="@/static/center/AI.png"
              style="width:56rem;height:56rem"
                 alt="">
            <span >
              AI答疑
            </span>

        </div>
      </div>
    <div class="top">
      <div class="top_block"
           @click="toPage('/templatePaper')"
           v-if="showTemplateTest&&showTop">

        <div class="images">
          <img src="@/static/index/template.png"
               alt="">
        </div>
        <div class="text">
          模板组卷
        </div>

      </div>
      <div class="top_block"
           @click="toPage('/testpaper/template')"
           v-if="showTop">

        <div class="images">
          <img src="@/static/index/test.png"
               alt="">
        </div>
        <div class="text">
          整卷测试
        </div>

      </div>
      <div class="top_block"
           @click="toPage('/teacherPaper')"
           v-if="showTop">

        <div class="images">
          <img src="@/static/center/teacher.png"
               alt="">
        </div>
        <div class="text">
          教师试卷
        </div>

      </div>
      <div class="top_block"
           @click="toPage('/chapter')"
           v-if="showTop&&isShow">

        <div class="images">
          <img src="@/static/center/zhangjie.png"
               alt="">
        </div>
        <div class="text">
          章节训练
        </div>

      </div>
      <div class="top_block"
           @click="toPage('/knowledge')"
           v-if="showTop">

        <div class="images">
          <img src="@/static/center/考点训练.png"
               alt="">
        </div>
        <div class="text">
          考点训练
        </div>

      </div>
      <div class="top_block"
           v-if="showTop"
           @click="toPage('/capability')">

        <div class="images">
          <img src="@/static/index/cap.png"
               alt="">
        </div>
        <div class="text">
          核心素养
        </div>

      </div>
      <div class="top_block"
           v-if="showTop"
           @click="toPage('/freedomTopic')">

        <div class="images">
          <img src="@/static/index/cap.png"
               alt="">
        </div>
        <div class="text">
          自由选题
        </div>

      </div>

      <div class="top_block"
           @click="toPage('/mytestpaper')"
           v-if="showTop">

        <div class="images">
          <img src="@/static/index/paper.png"
               alt="">
        </div>
        <div class="text">
          我的试卷
        </div>

      </div>

      <!-- <div class="top_block"
           @click="toPage('/errorBook')"
           v-if="showTop">

        <div class="images">
          <img src="@/static/index/ctb.png"
               alt="">
        </div>
        <div class="text">
          错题本
        </div>

      </div> -->
    </div>
      <div style="display:flex;margin-top:40rem;">
      <div class="progress">
        <div class="title">
          <span>考点弱点训练</span><span class="more"
                @click="toPage('/knowledgeWeak')">更多</span>
        </div>
        <div class="papers">

          <div class="paperItem"
               v-if="progressList.length>0"
               v-for="(item,index) in progressList"
               :key="index">
               <div class="paper" @click="toWeakInfo(item)">
            <div class="tag">
            {{item.knowledge_desc || item.lecture_name}}
            </div>
            <div class="score">
              <div>
                得分率(%): <span style="color:#FB9930;padding-right:20rem">{{item.rate}}</span>
              </div>
              <div>
                <img src="@/static/star1.png"
                     v-for="start in item.knowledge_point_star"
                     :key="start"
                     style="width:20rem;height:20rem; "
                     alt="">
              </div>
            </div>
            </div>
          </div>
           <div  v-else class="noData">暂无训练数据，请先进行训练~</div>
        </div>
      </div>

    </div>
  </div>
  <div style="display:flex;flex-direction: column;" >
    <div class="right"   :style="{'height': discuss ? '496rem' : '863rem'}">
      <div class="head">
        <span>学习进度</span>
        <span @click="toPage('/learnProgress')">更多</span>
      </div>
      <div class="content_wrap"  >
        <div class="text" v-if="dayiList.length==0">暂无数据</div>
        <div class="item"
             v-for="(item,index) in dayiList"
             @click="toDayi(item.discuss_id)"
             :key="index">
          <div class="topic_name">
            {{item.paper_desc}}
          </div>
          <div class="content">
            {{item.module_name}}
          </div>
            <div class="btn"
                 @click="doPaper(item)">继续做卷</div>
          <!-- <div class="btn" >
            {{item.discuss_re_times?`查看回复`:'暂无回复'}}
          </div> -->
        </div>
      </div>
    </div>
     <CardWeak ref="CardRef"
       v-if="discuss"
                title="线上答疑"

                url="/dayi"
                @toInfo="todayiInfo"
                btn_text="训练"
                :list="weakLlist" />
             </div>
  </div>

<div class="autoModal"
         v-if="autoModalFlag">
      <div class="openButton">

        <a-button type="warning"
                   @click="toBuy"
                   class="btntext"><span class="text">开通VIP享受全部功能</span></a-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { SearchOutlined } from '@ant-design/icons-vue'
import { reactive, ref, toRef, toRefs } from '@vue/reactivity'
import { backgColorProperty } from './property.js'
import { onMounted, onUnmounted } from '@vue/runtime-core'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { getHomeKnowledge, getHomeWeak } from '@/api/knowledge.js'
import { getTopic } from '@/api/topic.js'
import Card from './components/card.vue'
import CardWeak from './components/cardWeak.vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { getTestModeSubject } from "@/api/subject.js"
import { messageStatus,recordUseTime } from '@/api/home.js'
import { getLearnProcess } from '@/api/learnProcess.js'
import { backgoundColor } from './background.js'
import { getOnlineAnswer } from '@/api/post.js'
import { getUserInfoApi } from '@/api/user.js'


const router = useRouter()
let list = ref([])
let keywords = ref('')
let weakLlist = ref([])
let totalScore = ref(0)
let dayiList = ref([])
let autoModalFlag = ref(false)
let backgColor = backgColorProperty
let timeInterValId = ref(0)
let userInfo = reactive({})
let store = useStore()
const edu_grade_id = ref(null)
let bgColors = backgoundColor
let discuss = ref(1)

let unreadMsgCount = ref(0)
const timer = ref(null)
const timer1 = ref(null)
let progressList = ref([])

let aiChatState = ref(0)

const searchTopic = async () => {
  if (!keywords.value) {
    return message.warn('请输入题目ID')
  }
  const { data } = await getTopic({
    question_id: keywords.value
  })
  if (data.list.length) {
    router.push('/showTopic?topicId=' + keywords.value)
  }
}

onUnmounted(() => {
  if (timer1.value) {
    window.clearInterval(timer1.value)
    timer1.value = null
  }
})
onMounted(() => {
  edu_grade_id.value = JSON.parse(window.localStorage.getItem('userInfo'))?JSON.parse(window.localStorage.getItem('userInfo')).edu_grade_id:""
  getTestSubject()
  getKnowledge()
  getProgress()
  getWeakness()
  getUserInfo()
  getDayi()
  getAiChatState()
  discuss.value = JSON.parse(window.localStorage.getItem('userInfo')).discuss

  totalScore.value = JSON.parse(window.localStorage.getItem('totalScore'));
  // this.$EventBus.on('totalScoreEdit', data => {
  //   totalScore.value = data
  // })
   let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    if (userInfo.user_type_id == 101 && !userInfo.vip_end_time) {
      autoModalFlag.value = true
    }
  if (totalScore.value > 0) {
    window.localStorage.setItem('score_dialog', false)
  }
  store.commit('CLEAR_ROUTE_CACHE')

  getMsgUnread()
  reqMsgLoop()
  // getLoginStatus()
  console.log('8887987',!window.sessionStorage.getItem('isLogin') )
  const timerKey = '__loginTimer__'
  if (!window[timerKey]) {
    getLoginStatus()
    window[timerKey] = window.setInterval(getLoginStatus, 60000)
  }

     let subjectList = JSON.parse(window.localStorage.getItem('subjectListData'))
const hasChinese = subjectList.some(item => item.subject_id == 1);
const hasEnglish = subjectList.some(item => item.subject_id == 3);

if (subjectList.length == 1 && (hasChinese || hasEnglish) ||
    (subjectList.length == 2 && hasChinese && hasEnglish)) {

  isShow.value = false;
}else{

  isShow.value = true;
}
})

onBeforeRouteLeave((to, from, next) => {
  let includeRouteNames = ['/mytestpaper', '/testpaper/template', '/dayi/info']
  if (includeRouteNames.includes(to.name)) {
    store.commit('SET_ROUTE_LIST', to.name)
  }
  next()
})

onUnmounted(() => {
  window.clearTimeout(timer.value)

})
const toConsultation = () => {
  router.push('/consultation')
}

const getDayi = async () => {
  const { data } = await getLearnProcess()
  dayiList.value = data.list
}
const toPredict = () => {
  router.push('/predict')
}
const getProgress = async () => {
  const { data } = await getHomeWeak()
  progressList.value = data.list

}

const toGoal = () => {
  router.push('/userInfo/goal')
}
const toRank = () => {
    router.push('/studyRank')
}
// 获取用户信息
const getUserInfo = () => {
  let cacheUserInfo = JSON.parse(window.localStorage.getItem('userInfo'))
  for (const key in cacheUserInfo) {
    userInfo[key] = cacheUserInfo[key]
  }
}
const toBuy = () => {
  router.push('/buyVip')
}


let showTemplateTest = ref(false)
let showTop = ref(false) //等确定是否显示模板组卷再显示其它组卷模块
let isShow = ref(null)
// 获取备考科目
const getTestSubject = async () => {
  try {
    let { data } = await getTestModeSubject({has_district:1})
    console.log('data', data)
    if (data && data.list && data.list.length > 0) {
      showTemplateTest.value = true
    } else {
      showTemplateTest.value = false
    }
    showTop.value = true
  } catch {
    showTop.value = true
  }

}

// 跳转页面
const toPage = (str) => {
  router.push(str)
}
const getKnowledge = async () => {
  const { data } = await getHomeKnowledge()
  list.value = data.list
}

const getWeakness = async () => {
  const { data } = await getOnlineAnswer()
  weakLlist.value = data.list
}
//点击帖子条目跳转
const todayiInfo = (item) => {
  let form = {
    status: status.value
  }
  if (status.value == 2) {
    form.discuss_id = item.discuss_parent_id
  } else {
    form.discuss_id = item.discuss_id
  }
  router.push('/dayi/info?form=' + JSON.stringify(form))
}
const toInfo = (item) => {
  let form = {
    knowledge_id: item.knowledge_id,
    subject_id: item.subject_id
  }
  window.sessionStorage.removeItem('images')
  window.sessionStorage.removeItem('paper')
  window.sessionStorage.removeItem('testpaperCardIndex')
  // router.push('/testpaper/paperinfo?isKnowledge=1&form=' + JSON.stringify(form))
  router.push('/doPaper?isKnowledge=1&form=' + JSON.stringify(form))

}

const toWeakInfo = (item) => {
  let form = {
    knowledge_id: item.knowledge_id,
    subject_id: item.subject_id
  }
  window.sessionStorage.removeItem('images')
  window.sessionStorage.removeItem('paper')
  window.sessionStorage.removeItem('testpaperCardIndex')
  router.push('/doPaper?isKnowledgeWeak=1&form=' + JSON.stringify(form))

}
const doPaper = (item) => {
  window.localStorage.removeItem('testpaperCardIndex')
  window.localStorage.removeItem('paper')
  window.localStorage.removeItem('images')
  router.push('/doPaper?user_paper_id=' + item.user_paper_id)
}


const getMsgUnread = async () => {
  try {

    var res = await messageStatus({ platform: 1, client: 1, uid: userInfo.user_id })
  } catch (error) {
    console.log(error)
    window.clearTimeout(timer)
  }

  unreadMsgCount.value = res.data.unread
}

const reqMsgLoop = () => {
  timer.value = window.setTimeout(async () => {
    getMsgUnread()
    reqMsgLoop()
  }, 5000)
}
const startLoginCheck = () => {
  // 立即执行一次
  // getLoginStatus()

  // 每 60 秒执行一次
  timer1.value = window.setInterval(async () => {
    await getLoginStatus()
  }, 60000)
}
const getLoginStatus = async () => {
  try {
    console.log('sss888',Date.now())
    await recordUseTime()
  } catch (error) {
    console.log(error)
    if (timer1.value) {
      window.clearTimeout(timer1.value)
      timer1.value = null
    }
  }
}
const toMsg = async () => {
  router.push('/message')
}

const getAiChatState = async ()=>{
  const { data } = await getUserInfoApi()
  aiChatState.value = data.show_chat
}

</script>

<style lang="scss" scoped>
.index_warp {
 .autoModal {
    position: fixed;
    left: 190rem !important;
    top: 0;
    width: 90%;
    height: 100%;
    opacity: 1.5;
    z-index: 1031;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    .btntext {
      position: fixed;
      left: 800rem;
      top: 700rem;
      .text {
        color: var(--light-333333, #333);
        text-align: center;

        font-size: 24rem;
        font-style: normal;
        font-weight: 600;
        line-height: 36rem; /* 150% */
      }
    }
    .openButton {
      ::v-deep .ant-btn {
        display: flex;
        width: 360rem;
        height: 64rem;
        justify-content: center;
        align-items: center;
        gap: 10rem;
        flex-shrink: 0;
        border-radius: 8rem;
        background: linear-gradient(100deg, #fdecc9 0%, #e9c383 100%);
        box-shadow: 0rem 8rem 16rem 0rem rgba(0, 0, 0, 0.1);
      }
    }
  }
  // margin: 0 auto;
  margin-top: 4vh;
  // margin-left: 90rem;
  margin-left: 4.76vw;

  .mode {
    margin-bottom: 7rem;
    font-size: 22rem;
    font-weight: 800;
    color: #ffffff;
    text-indent: 5rem;
  }
  .progress {

      width: 1000rem;
      height: 328rem;

      background: rgba(1, 61, 253, 0.6);
      border-radius: 50rem;
      overflow: hidden;
      .more {
        padding: 2rem 40rem;
        font-size: 28rem;
        background: rgba(0, 0, 0, 0.1);
        font-weight: 400;
        color: #ddd;
        border-radius: 35rem;
        cursor: pointer;
      }
      .title {
        font-size: 28rem;
        font-weight: 600;
        color: #ffffff;
        margin-top: 20rem;
        margin: 20rem 32rem 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .papers {
        &::-webkit-scrollbar-thumb {
          background-color: #ffffff52;
        }

        display: flex;
        margin:20rem 0rem 20rem 32rem;
        overflow-x: scroll;
        gap:24rem;
        .noData{
           display:flex;
  justify-content: center;
  margin-top: 40rem;
  color: var(--dark-60-ffffff, rgba(255, 255, 255, 0.60));

font-size: 20rem;
font-style: normal;
font-weight: 400;
height: 140rem;
line-height: 30rem; /* 150% */
margin-left: 348rem;
        }
        .paperItem{
          display: flex;
width: 224rem;
height: 198rem;
min-width: 224rem;
padding: var(--Spacing-S, 8rem);
// flex-direction: column;
align-items: flex-start;
border-radius: 48rem;
background: #B29BFA;
        .paper {
         display: flex;
padding: var(--Spacing-L, 24rem);
flex-direction: column;
align-items: flex-start;
gap: 10rem;
flex: 1 0 0;
align-self: stretch;
border-radius: 40rem;
background: #FFF;
box-shadow: 0rem 2rem 8rem 0rem #622FD7;

          .tag {
           overflow: hidden;
color: var(--light-333333, #333);
text-align: center;
text-overflow: ellipsis;
display: flex;
height: 72rem;
justify-content: center;
align-items: center;
align-self: stretch;
font-size: 20rem;
font-style: normal;
font-weight: 600;
line-height: 30rem; /* 150% */
          }
          .score{
            display: flex;
flex-direction: column;
align-items: flex-start;
gap: var(--Spacing-XS, 4rem);
align-self: stretch;
font-size:16rem


          }
          .content {
            margin-top: 70rem;
            height: 60rem;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            font-size: 24rem;
            line-height: 33rem;
            font-weight: bold;
            padding: 0 10rem;
          }
          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 22rem;
            font-weight: bold;
            color: #000000;
            background-color: #ffffff;
            margin: 0 auto;
            width: 130rem;
            height: 44rem;
            border-radius: 40rem;
            margin-top: 9rem;
            cursor: pointer;
          }
          .time {
            font-size: 20rem;
            font-weight: 500;
            color: #0d2878;
            text-align: center;
            margin-top: 10rem;
          }
        }
      }}
    }
    .right {
    width: 480rem;
    height: 496rem;
    box-shadow: 0rem 0rem 0rem 0rem rgba(229, 229, 229, 1);
    background: #fefdf9;
    border-radius: 60rem;
    border: 20rem solid #fac376;
    margin-left: 40rem;
    overflow: hidden;
    margin-top: 20rem;
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        margin-top: 24rem;
        &:nth-child(1) {
          text-indent: 34rem;
          font-size: 24rem;
          font-weight: 600;
          color: #1A1A1A;
        }
        &:nth-child(2) {
          color: #999;
          font-weight: 400;
          font-size: 24rem;
          margin-right: 24rem;
          cursor: pointer;
        }
      }
    }
    .content_wrap {
      .text{
            display: flex;
    justify-content: center;
    margin-top: 39%;

    color: var(--light-cccccc, #CCC);


font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 30px; /* 150% */
      }
      overflow-y: scroll;
      height: 695rem;
      /* 滚动条上的滚动滑块. */
      &::-webkit-scrollbar-thumb {
        background-color: #d4af49da;
      }
      /*  滚动条轨道. */
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6rem rgba(196, 129, 4, 0.5);
        box-shadow: inset 0 0 6rem rgba(196, 129, 4, 0.5);
      }
    }
    .item {
      position: relative;
      width: 380rem;
      height: 190rem;
      border-radius: 10rem;
      box-shadow: 0rem 0rem 4rem -1rem rgba(177, 177, 177, 0.5);
      background: #ffe9e0;
      margin: 0 auto;
      margin-top: 20rem;
      margin-bottom: 30rem;
      overflow: hidden;
      .topic_name {
        margin: 15rem 20rem 8rem;
        font-weight: bold;
        font-size: 24rem;
        color: #b76c3c;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .content {
        padding: 0 20rem;
        font-weight: 500;
        color: #666666;
        font-size: 20rem;
        line-height: 28rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .btn {
        position: absolute;
        bottom: 16rem;
        right: 20rem;
        // background: #ff664e;
        border-radius: var(--Radius-MAX, 100rem);
        border: 1rem solid #FF664E;
        font-size: 16rem;
        font-weight: 400;
        color: #FF664E;
        padding: 7rem 21rem;
        margin-top: 16rem;
        cursor: pointer;
      }
    }
  }
  .left{
    margin-top:20rem;
  }
  .topList{
    display: flex;
    gap:16rem;
            cursor: pointer;
    .topCard{
      display: flex;
justify-content: center;
align-items: center;
gap: var(--Spacing-S, 8rem);
flex: 1 0 0;
width:187rem;
height:88rem;
align-self: stretch;
border-radius: var(--Radius-L, 28rem);
background: linear-gradient(100deg, #088BFF 0%, #63EFFF 100%);
box-shadow: 4rem 4rem 4rem 0rem rgba(255, 255, 255, 0.60) inset, 0rem 2rem 10rem 0rem rgba(3, 48, 143, 0.60);
span{
  color: var(--light-333333, #333);

font-size: 20rem;
font-style: normal;
font-weight: 600;
line-height: 30rem; /* 150% */
}
    }
  }
  .top {
    display: flex;
    padding: var(--Spacing-L, 24rem);
    align-items: flex-start;
    align-content: flex-start;
    align-self: stretch;
    flex-wrap: wrap;
    width:1000rem;
    height:368rem;
    margin-top: 40rem;
    border-radius: 48rem;
    background: linear-gradient(130deg, #b6cdf6 0%, #fff 79.81%);
    box-shadow: 2rem 2rem 6rem 0rem rgba(255, 255, 255, 0.6) inset,
      0rem 2rem 10rem 0rem rgba(3, 48, 143, 0.6);
    .top_block {
      display: flex;
width: 238rem;
height: 160rem;
flex-direction: column;
justify-content: center;
align-items: center;
gap: var(--Spacing-XS, 4rem);

      .white_wrap {
        width: 302rem;
        width: calc(100% - 16rem);
        height: 352rem;
        margin: 8rem;
        padding: 32rem;
        background: #ffffff;
        box-shadow: 0rem 2rem 6rem 0rem #be771f;
        border-radius: 24rem;
      }
      .text {
        font-size: 24rem;
        // font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 400;
        color: #1a1a1a;
        line-height: 36rem;
        // margin-bottom: 16rem;
      }
      .content {
        font-size: 20rem;
        font-weight: 400;
        line-height: 30rem;
        color: #666666;
        span {
          display: block;
          margin-bottom: 4rem;
        }
      }
      .images {

        img {
          width: 80rem;
          height: 80rem;
          // position: absolute;
        }
      }
    }
  }
}
.top_input {
  margin-top: 20rem;
  width: 91%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  :deep .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused {
    box-shadow: 0 0 0;
  }
  .goal_text {
    color: var(--light-333333, var(--neutral-color-333333, #fff));
    font-size: 24rem;
    font-style: normal;
    font-weight: 700;
    line-height: 32rem; /* 131.25% */
  }
  .btn_goal {
    display: flex;
    padding: var(--spacer-8_xs, 8rem) var(--spacer-24_m, 24rem);
    align-items: center;
    gap: var(--spacer-8_xs, 8rem);
    border-radius: 100rem;
    border: 1rem solid #f37f21;
    background: #f37f21;
    .text {
      overflow: hidden;
      color: var(--light-ffffff, #fff);
      text-overflow: ellipsis;
      font-size: 20rem;
      font-style: normal;
      font-weight: 600;
      line-height: 30rem; /* 150% */
    }
  }
  .ant-input-affix-wrapper {
    width: 320rem;
    height: 48rem;
    padding: 0rem;
    box-shadow: 0;
    // border-radius: 30rem;
    padding-right: 12rem;
    background: transparent;
    border: 0;
    border-bottom: 1rem solid rgba(255, 255, 255, 0.38);
    font-weight: 400;

    :deep .ant-input-suffix {
      color: #fff;
      padding: 0 0rem;
      img {
        width: 32rem;
        height: 32rem;
        cursor: pointer;
      }
    }
    :deep .ant-input {
      font-size: 24rem;
      line-height: 36rem;
      font-weight: 400;
      padding: 0;
      color: rgba(255, 255, 255, 0.38);
      &::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.38);
        font-weight: 400;
      }
      &::-moz-placeholder {
        color: rgba(255, 255, 255, 0.38);
        font-weight: 400;
      }
    }
  }
  .ant-input-affix-wrapper-focused {
    // background-color: rgb(250, 250, 250, 1);
    box-shadow: 0 0 0;
    :deep .ant-input-suffix {
      // color: #336;
    }
    :deep .ant-input {
      // color: #336;
      color: #fff;
      &::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 0.38);
      }
      &::-moz-placeholder {
        color: rgba(255, 255, 255, 0.38);
      }
    }
  }

  :deep .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 0;
  }
  :deep .ant-input {
    background-color: transparent;
    padding-left: 12rem;
    &::-webkit-input-placeholder {
      color: #eeeeff;
    }
    &::-moz-placeholder {
      color: #eeeeff;
    }
  }
}

.msg-count {
  display: flex;
  padding: 4rem 12rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
  border-radius: 16rem;
  // border: 1rem solid #fff;
  background: var(--Error-color_06, #f44336);
  color: #fff;
  font-size: 16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 24rem;
  position: relative;
  top: -12rem;
  left: -12rem;
}
</style>